export interface AutoCompleteBlock {
  name: string | null
  reason: string
}

// Motivos que a API devolve em `blocked`. Traduzir na fronteira mantém o
// vocabulário do backend intacto e legível para quem está dando suporte.
export const AUTO_COMPLETE_REASON_LABELS: Record<string, string> = {
  level_locked: 'nível bloqueado ou agendado pelo gestor',
  journey_locked: 'jornada anterior não concluída',
  challenge_done: 'desafio já concluído e a jornada não permite refazer',
  unlock_rule_school_in_list: 'regra de escola',
  unlock_rule_school_not_in_list: 'regra de escola',
  unlock_rule_state_in_list: 'regra de estado',
  unlock_rule_state_not_in_list: 'regra de estado',
  unlock_rule_school_year_in_list: 'regra de série',
  unlock_rule_school_year_not_in_list: 'regra de série',
  unlock_rule_group_in_list: 'regra de grupo',
  unlock_rule_campaign_in_list: 'regra de campanha',
  unlock_rule_campaign_not_in_list: 'regra de campanha',
  unlock_rule_available_from: 'janela de tempo',
  unlock_rule_available_between: 'janela de tempo',
  unlock_rule_reward_item_delivered: 'exige um resgate entregue',
  unlock_rule_wallet_points_minimum: 'exige um mínimo de pontos'
}

/**
 * Descreve um bloqueio que a auto-conclusão NÃO contornou. Um motivo
 * desconhecido volta cru em vez de virar texto genérico: numa ferramenta de
 * diagnóstico, o código exato vale mais do que "algo deu errado".
 */
export function describeAutoCompleteBlock(item: AutoCompleteBlock): string {
  const reason = AUTO_COMPLETE_REASON_LABELS[item.reason] ?? item.reason

  return item.name ? `${item.name}: ${reason}` : reason
}
